import Alpine from 'alpinejs'

import Politician from './components/politician'
import Politicians from './components/politicians';
import Search from './components/search';

window.Alpine = Alpine

Alpine.data('politician', Politician);
Alpine.data('politicians', Politicians);
Alpine.data('search', Search);

Alpine.start()
